const DashboardHeader = () => {
  return null;
};

export default DashboardHeader;
